import React from 'react';
import { Section, WhatsAppButton } from './Shared';
export function CTA() {
  return <Section bg="slate" className="border-t border-slate-200" data-id="element-34">
      <div className="max-w-4xl mx-auto text-center space-y-8" data-id="element-35">
        <h2 className="text-4xl md:text-5xl font-bold text-slate-900 leading-tight" data-id="element-36">
          Tu vejez merece una decisión informada. No una suposición.
        </h2>

        <div className="text-lg md:text-xl text-slate-700 space-y-4 max-w-3xl mx-auto" data-id="element-37">
          <p data-id="element-38">
            Llevas años construyendo tu futuro con cada cotización. Lo menos que
            mereces es saber exactamente cuánto recibirás por ese esfuerzo.
          </p>
          <p data-id="element-39">No en rangos vagos. No en proyecciones optimistas de tu fondo.</p>
          <p className="font-semibold text-slate-900" data-id="element-40">
            En pesos reales. Calculados con tu historial. Explicados en tu
            idioma.
          </p>
          <p data-id="element-41">Eso es lo que hacemos en Solución a Pensión.</p>
          <p data-id="element-42">Y lo hacemos directo a tu WhatsApp.</p>
        </div>

        <div className="pt-8 flex flex-col items-center gap-4" data-id="element-43">
          <WhatsAppButton text="QUIERO MI ASESORÍA PENSIONAL — ESCRÍBENOS AHORA POR WHATSAPP" size="lg" className="w-full sm:w-auto text-sm sm:text-base shadow-xl" data-id="element-44" />
          <p className="text-sm text-slate-500 font-medium" data-id="element-45">
            Sin compromisos. Sin formularios largos. Solo cuéntanos tu caso y
            empezamos.
          </p>
        </div>
      </div>
    </Section>;
}